// Standard elevated-card drop shadow used on tool/source/client cards.
// Three layers (1px contact + 2px ambient + 4px diffuse) keep the card
// reading as raised without looking heavy on the moon-dust background.
export const CARD_SHADOW =
  '0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 2px 6px 0 rgba(0, 0, 0, 0.05), 0 4px 12px 0 rgba(0, 0, 0, 0.01)'
